<template>
  <div id="event-information">
    <call />
    <pop-alert />
    <!-- header -->
    <header>
      <header-app :rate="counterBlock" :canMobileOrder="isMobileOrderEnabled()"></header-app>
      <span><menu-app></menu-app></span>
      <div class="ssm-overlay ssm-toggle-nav"></div>
    </header>
    <!-- main -->
    <main>
      <!-- nav bot -->
      <footer-app page="events"></footer-app>
      <!-- event information -->
      <section :class="{'fade-base': true, 'fade': pageFade}">
        <div class="l-event">
          <div class="l-event__head bg-transparent l-main--bg-border pt-64">
            <div class="l-list-menu">
              <div class="l-list-menu__tab">
                <!-- swiper_tab -->
                <div class="swiper-container c-tab-menu js-swiper_tab">
                  <div class="swiper-wrapper c-tab-menu__wrap">
                    <div :class="{'swiper-slide':true, 'c-tab-nav__item': true, 'is-active': initialTab == 0}">イベント一覧</div>
                    <div :class="{'swiper-slide':true, 'c-tab-nav__item': true, 'is-active': initialTab == 1}">イベントカレンダー</div>
                  </div>
                </div>
                <!-- js-_body -->
                <div class="swiper-container js-swiper_tab_body">
                  <div class="swiper-wrapper">
                    <!-- //// イベント 一覧 //////////////////////////////////// -->
                    <div class="swiper-slide">
                      <div class="l-event__body">
                        <ul class="c-list-event c-list-event--sale mb-24">
                          <li v-for="(event, index) in eventAllList" :key="index">
                            <div v-if="event.eventType=='shop'">
                              <router-link :to="`/event/detail/${SHOP_ID}/${event.id}`" class="h-auto">
                                <div class="c-list-event__sale-info">
                                  <div class="c-list-event__sale-info--top">
                                    <h6>{{ event.title }}</h6>
                                  </div>
                                </div>
                                <div class="c-list-event__time">
                                  <div v-html="formatEventTerm2(event)"></div>
                                </div>
                              </router-link>
                            </div>
                            <div v-else>
                              <router-link :to="`/event/detail/${event.provider.id}/${event.id}`" class="h-auto">
                                <div class="c-list-event__sale-info">
                                  <div class="c-list-event__sale-info--top">
                                    <div class="c-tag c-tag--number w-auto" v-if="event.provider && event.provider.floorGuideNo">{{event.provider && event.provider.floorGuideNo}}</div>
                                    <h6>{{ event.provider.shopName }}</h6>
                                  </div>
                                  <p>{{ event.title }}</p>
                                </div>
                                <div class="c-list-event__time">
                                  <div v-html="formatEventTerm2(event)"></div>
                                  {{event.provider && event.provider.location}}
                                </div>
                              </router-link>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <!-- //// イベント カレンダー //////////////////////////////////// -->
                    <div class="swiper-slide">
                      <div class="l-event__calendar bg-white">
                        <v-calendar class="event-calendar" :attributes='attrs' v-model="currentDate" @dayclick='getDateCalendar' ref="calendar" :disable-page-swipe="true" navVisibility="false">
                            <template slot="header-title" slot-scope='props'>
                              {{props.yearLabel}}.{{props.month}}
                            </template>
                            <template slot='day-content' slot-scope='props'>
                              <a class="vc-day-box-center-center vc-day" @click.prevent="getDateCalendar(props.day)">
                                <div class="vc-day-content vc-focusable vc-font-medium vc-text-sm vc-cursor-pointer focus:vc-font-bold vc-rounded-full">
                                  {{props.day.day}}
                                  <template v-for="src in getEventIcon(props)">
                                      <img :src="src" :key="src" />
                                  </template>
                                </div>
                              </a>
                            </template>
                        </v-calendar>
                      </div>
                      <div class="l-event__body">
                        <div class="c-calendar-ct mb-8">
                          <button class="c-calendar-ct__btn c-calendar-ct__btn--left" @click="prevDay"></button>
                          <div class="c-calendar-ct__text">本日{{ currentDate.getMonth()+1 }}/{{ currentDate.getDate() }}のイベント（{{ eventAeon.length + eventProvider.length }}）</div>
                          <button class="c-calendar-ct__btn c-calendar-ct__btn--right" @click="nextDay"></button>
                        </div>
                        <div v-if="eventAeon && eventAeon.length" class="l-event__title">イオンタウンイベント</div>
                        <ul class="c-list-event c-list-event--sale mb-24">
                          <li v-for="(event, index) in eventAeon" :key="index">
                            <router-link :to="`/event/detail/${SHOP_ID}/${event.id}`" class="h-auto">
                              <div class="c-list-event__sale-info">
                                <div class="c-list-event__sale-info--top">
                                  <h6>{{ event.title }}</h6>
                                </div>
                              </div>
                              <div class="c-list-event__time" v-if="event.source != 'aeontown.co.jp'">
                                {{ formatTime(event.eventStartAt, event.eventEndAt) }}
                              </div>
                            </router-link>
                          </li>
                        </ul>
                        <div v-if="eventProvider && eventProvider.length" class="l-event__title">ショップイベント</div>
                        <ul class="c-list-event c-list-event--sale mb-24">
                          <li v-for="(event, index) in eventProvider" :key="index">
                            <router-link :to="`/event/detail/${event.provider.id}/${event.id}`" class="h-auto">
                              <div class="c-list-event__sale-info">
                                <div class="c-list-event__sale-info--top">
                                  <div class="c-tag c-tag--number w-auto" v-if="event.provider && event.provider.floorGuideNo">{{event.provider && event.provider.floorGuideNo}}</div>
                                  <h6>{{ event.provider.shopName }}</h6>
                                </div>
                                <p>{{ event.title }}</p>
                              </div>
                              <div class="c-list-event__time">
                                {{ formatTime(event.eventStartAt, event.eventEndAt) }}<br />{{event.provider && event.provider.location}}
                              </div>
                            </router-link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <loader :loading="loading" />
      <!-- modal show congestion degree in header -->
      <modal_congestion_situation :counter-blocks=counterBlocks></modal_congestion_situation>
      <!-- modal show required login -->
      <modal_login_required></modal_login_required>
      <alert :message="alert_msg" 
      :show="alert_show" 
      :closeModal="closeModal" 
      :confirm_show="confirm_show" 
      :confirm_message="confirm_msg" 
      :confirm_callback="confirm_callback" 
      :confirm_hide_cancel="confirm_hide_cancel"
      :label_cancel="confirm_label_cancel"
      :label_ok="confirm_label_ok"
      ></alert>
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import Menu from "../components/Menu.vue";
import Alert from "../components/Alert.vue";
import ModalCongestionSituation from "../components/ModalCongestionSituation.vue";
import ModalLoginRequired from "../components/ModalLoginRequired.vue";
import Swiper from "swiper";
import Calendar from 'v-calendar/lib/components/calendar.umd';
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import { 
  getLocalAllEvents,
  getServerAllEvents
} from "../store/firestore.js";
import { DB, EVENT_COLLECTION_KEY } from "../config/const.js";
const $ = window.$;
import dayjs from "dayjs";
import PopAlert from "../components/PopAlert.vue";
import firebase from "../common/firebaseProject";
import loader from "../components/parts/loader.vue"

export default Vue.extend({
  name: "Events",
  components: {
    'footer-app': Footer,
    'header-app': Header,
    'menu-app': Menu,
    'modal_congestion_situation': ModalCongestionSituation,
    'modal_login_required': ModalLoginRequired,
    'v-calendar': Calendar,
    'alert': Alert,
    "loader":loader,
    PopAlert,
  },
  mixins: [Tenant],
  data () {
    return {
      attrs: [
        {
          key: 'today',
          highlight: true,
          dates: new Date(),
        }
      ],
      eventAllList: [],
      eventProvider: [],
      eventAeon: [],
      currentDate: Common.getUrlParam('date') || dayjs().format("YYYY-MM-DD"),
      currentMonth: null,
      EVENT_COLLECTION_KEY: EVENT_COLLECTION_KEY,
      swiper_tab_body: null,
      initialTab: Common.getUrlParam('tab') || 0,
      loading: false,
    }
  },
  async created () {
    this.currentDate = new Date(this.currentDate)
    this.getEventAllList();
    this.swiper_tab_body?.updateAutoHeight();
  },

  mounted() {
    var _this = this;

    function setCurrentSlide(ele, index) {
      $(".js-swiper_tab .swiper-slide").removeClass("is-active");
      ele.addClass("is-active");
      //swiper_tab.initialSlide=index;
    }

    // タブ
    var swiper_tab = new Swiper('.js-swiper_tab', {
      slidesPerView: 2,
      initialSlide: this.initialTab,
      paginationClickable: true,
      freeMode: true,
      // centeredSlides: true,
      loop: false,
      onTab: function (swiper) {
        var n = swiper_tab.clickedIndex;
      }
    });

    $.each(swiper_tab.slides, function (index, val) {
      var ele = $(this);
      ele.on("click", function () {
        setCurrentSlide(ele, index);
        if(index != _this.$route.query.tab){
          _this.$router.replace({ query: { tab: index } });
        }
        swiper_tab_body.slideTo(index, 500, false);
        // mySwiper.initialSlide=index;
      });
    });

    var swiper_tab_body = new Swiper('.js-swiper_tab_body', {
      direction: 'horizontal',
      loop: false,
      initialSlide: this.initialTab,
      autoHeight: true,
      on: {
        slideChangeTransitionEnd: function () {
          if(!swiper_tab_body) return;
          var n = swiper_tab_body.activeIndex;
          setCurrentSlide($(".js-swiper_tab .swiper-slide").eq(n), n);
          if(n != _this.$route.query.tab){
            _this.$router.replace({ query: { tab: n } });
          }
          swiper_tab.slideTo(n, 500, false);
        },
      }
    });
    this.swiper_tab_body = swiper_tab_body;

    Common.initDom();

  },
  updated() {
    this.swiper_tab_body?.updateAutoHeight();

    this.$nextTick(function () {
      Common.setKeepRatio()
    })
  },
  methods: {
    async getEventProviderToDate(day) {
      //this.eventProvider = await getEventsProviderToDate(day)
      let todayStart = dayjs(day).startOf('day').valueOf();
      let todayLast = dayjs(day).endOf('day').valueOf();
      this.eventProvider = this.eventAllList.filter(event => {
        if (event.eventType == 'shop') {
          return false;
        }
        if (event.eventStartAt < todayLast){
          if (!event.closeAt || event.closeAt >= Date.now()){
            if (!event.eventEndAt || event.eventEndAt >= todayStart){
              return true;
            }
          }
        }
        return false;
      });
    },

    async dayEventAeonToDate(day) {
      //this.eventAeon = await getEventsAeonToDate(day)
      let todayStart = dayjs(day).startOf('day').valueOf();
      let todayLast = dayjs(day).endOf('day').valueOf();
      this.eventAeon = this.eventAllList.filter(event => {
        if (event.eventType != 'shop') {
          return false;
        }
        if (event.eventStartAt < todayLast){
          if (!event.closeAt || event.closeAt >= Date.now()){
            if (!event.eventEndAt || event.eventEndAt >= todayStart){
              return true;
            }
          }
        }
        return false;
      });
    },

    getDateCalendar(day) {
      this.currentDate = new Date(day.date)
      const dateId = '.id-'+dayjs(day.date).format('YYYY-MM-DD')
      this.getEventProviderToDate(this.currentDate)
      this.dayEventAeonToDate(this.currentDate)
      $('.vc-border-purple').removeClass('vc-border-purple');
      $(dateId).addClass('vc-border-purple');
      if(this.$route.query.date != dayjs(day.date).format('YYYY-MM-DD')){
        this.$router.replace({ query: { tab: Common.getUrlParam('tab'), date: dayjs(day.date).format('YYYY-MM-DD') } });
      }
    },
    async getEventAllList() {
      this.eventAllList = await getLocalAllEvents()
      this.getDateCalendar({
        //date: this.currentDate.getFullYear() + "-" + (this.currentDate.getMonth() + 1) + "-" + this.currentDate.getDate()
        date: this.currentDate.toString()
      })
      this.currentMonth = this.getSelectMonth(this.currentDate); 

      setTimeout(async () => {
        this.eventAllList = await getServerAllEvents()
        this.getDateCalendar({
          //date: this.currentDate.getFullYear() + "-" + (this.currentDate.getMonth() + 1) + "-" + this.currentDate.getDate()
          date: this.currentDate.toString()
        })
        this.currentMonth = this.getSelectMonth(this.currentDate); 
      });
    },

    async nextDay() {
      const date = this.currentDate.setDate(this.currentDate.getDate() + 1);
      this.currentDate = new Date(date)
      this.attrs[0].dates = this.currentDate
      $('.vc-border-purple').removeClass('vc-border-purple')
      const str = `.id-${this.setDateTime(this.currentDate)}`
      $(str).addClass('vc-border-purple')
      this.getEventProviderToDate(this.currentDate)
      this.dayEventAeonToDate(this.currentDate)
      const currentYear = this.currentDate.getFullYear()
      const currentMonth = this.currentDate.getMonth()

      // update calendar when change date
      const calendar = this.$refs.calendar
      await calendar.move({month: currentMonth + 1, year: currentYear})
      $(str).addClass('vc-border-purple')

      let nextMonth = this.getSelectMonth(this.currentDate);
      if (this.currentMonth != nextMonth) {
        this.currentMonth = this.getSelectMonth(this.currentDate);
      }
    },

    async prevDay() {
      const date = this.currentDate.setDate(this.currentDate.getDate()-1);
      this.currentDate = new Date(date)
      $('.vc-border-purple').removeClass('vc-border-purple')
      const str = `.id-${this.setDateTime(this.currentDate)}`
      $(str).addClass('vc-border-purple')
      this.getEventProviderToDate(this.currentDate)
      this.dayEventAeonToDate(this.currentDate)
      const currentYear = this.currentDate.getFullYear()
      const currentMonth = this.currentDate.getMonth()

      // update calendar when change date
      const calendar = this.$refs.calendar
      await calendar.move({month: currentMonth + 1, year: currentYear})
      $(str).addClass('vc-border-purple')

      let nextMonth = this.getSelectMonth(this.currentDate);
      if (this.currentMonth != nextMonth) {
        this.currentMonth = this.getSelectMonth(this.currentDate);
      }
    },
    getEventIcon(dateData) {
      if (dateData.day.inMonth == false) {
        return null;
      }
      var results = [];
      this.eventAllList.map(event => {
        let eventStartAt = dayjs(event.eventStartAt).hour(0).minute(0).second(0).valueOf();
        let eventEndAt = dayjs(event.eventEndAt).hour(23).minute(59).second(59).valueOf();
        if (dayjs(dateData.day.date).valueOf() >= eventStartAt &&
          (!event.eventEndAt || dayjs(dateData.day.date).valueOf() <= eventEndAt)) {
          let img = '';
          switch (Number(event.icon)) {
            case 1:
              img = '/assets/images/calendar-icon-1.png';
              break;
            case 2:
              img = '/assets/images/calendar-icon-2.png';
              break;
            case 3:
              img = '/assets/images/calendar-icon-3.png';
              break;
            case 4:
              img = '/assets/images/calendar-icon-6.png';
              break;
            case 5:
              img = '/assets/images/calendar-icon-5.png';
              break;
            case 6:
              img = '/assets/images/calendar-icon-4.png';
              break;
            default:
              break;
          }
          if (img && results.length < 2 && !results.includes(img)) {
              results.push(img);
          }
        }
      })
      return results;
    },   
  }
})
</script>
